export const TRANSITION_TIMEOUT_TIME = 400;

// Brands shown by dynamic Select and Connect when the component toggle turns it
// on and the loader has not sent a count. Mirrors the loader's own default and limit.
export const DYNAMIC_SELECT_AND_CONNECT_DEFAULT_MAX_BRANDS = 4;

export const NAVIGATION_BLOCKS = {
  CUSTOMER_MATCHES: 'CUSTOMER_MATCHES',
  APPOINTMENT_BOOKING: 'APPOINTMENT_BOOKING',
  GET_DYNAMIC_NEWSLETTER: 'GET_DYNAMIC_NEWSLETTER',
  SELECT_AND_CONNECT: 'SELECT_AND_CONNECT',
};

// The cause of the submission block. Currently only INPUT_VALUE is supported but in future we could have causes such as results of a external API call.
export const SUBMISSION_BLOCK_TYPES = {
  INPUT_VALUE: 'INPUT_VALUE',
};

// The message to be shown to the customer when a submission block is encountered.
export const SUBMISSION_BLOCK_MESSAGES = {
  INVALID_POSTCODE:
    'Sorry, we are unable to connect you with a provider nearby.',
};

/**
 * If any of these statements change, the hash needs to be updated.
 * Use the https://eagle.mvfglobal.com/api/v1/legal-statement/import endpoint to import the new statement wording.
 * The hash can be put in the corresponding entry in the STATEMENT_HASH_OVERRIDES object.
 */
export const STATEMENT_OVERRIDES = {
  EMAIL_ONLY:
    "By entering your email, you agree to Marketing VF Ltd collecting and using the data you've submitted up to this point to sign you up for updates about this and other related products. Unsubscribe at any time.",
};

export const STATEMENT_HASH_OVERRIDES = {
  EMAIL_ONLY: 'fa03cb0c9cd6c97f8ddab6beaf576962',
};

export const SUBCATEGORY_IDS_WITH_POSTCODE_CONSTRAINTS = [
  '9f800eea-749a-6c44-e2ab-6151af6871d7', // Auto Warranty US
];

export const POSTCODE_BLOCK_MESSAGES_BY_SUBCATEGORY = {
  '9f800eea-749a-6c44-e2ab-6151af6871d7':
    'Sorry we are unable to match you with a provider nearby. GoWizard does not do business in California at this time. The information and resources provided on this site are not intended to be accessed by residents of California', // Auto Warranty US
};
